<template>
  <v-btn
    color="#8E8E8E"
    height="50"
    class="text-none rounded-lg"
    style="font-family: Montserrat"
    @click="login"
    :loading="loading"
    block
    outlined
  >
    <div class="d-flex align-center justify-center">
      <div class="d-flex align-center justify-start" style="width: 170px">
        <div>
          <v-img
            :src="logo_microsoft"
            :width="20"
            :height="20"
            contain
            class="login-button-logo me-3"
          />
        </div>
        <div class="login-action-text">{{ $t("login.loginMicrosoft") }}</div>
      </div>
    </div>
  </v-btn>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "LoginWithMicrosoft",

  data() {
    return {
      logo_microsoft: require("@/assets/images/logo_microsoft.png"),
      loading: false,
    };
  },

  methods: {
    ...mapActions(["callLoginMicrosoft"]),

    login() {
      this.loading = true;

      this.callLoginMicrosoft().finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
.login-button-logo {
  mix-blend-mode: multiply;
}
</style>
